<script>
import { Bar } from 'vue-chartjs'
export default {
	extends: Bar,
	props: {
		labels: {
			type: Array,
			required: true
		},
		datasets: {
			type: Array,
			required: true
		}
	},
	mounted () {
		this.buildChart()
	},
	methods: {
		buildChart () {
			this.renderChart({
				labels: this.labels,
				datasets: this.datasets
			}, {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/charts/chart-bar.vue